'use client';

import {styled} from "@mui/system";
import {Typography, TypographyProps} from "@mui/material";

const InfoItemDescription = styled(({...props }: TypographyProps) => (
    <Typography {...props} />
))(({ theme }) => ({
    display: 'contents',
    color: theme.palette.custom.slateGray
}));

export default InfoItemDescription;
